import { fork, select, call, put } from 'redux-saga/effects';
import { homeRequest } from 'core/services/product';

import { takeEvery, all } from 'redux-saga/effects';
import { IActionFeed, selectActionFeed } from 'core/selectors/product/action/actionFeed';
import { goToIndex, setIndex } from 'core/slices/register';
import { handlePlayerResponse } from './response';

function* homeFullfilledSaga(action) {
  yield handlePlayerResponse(action.payload);
  const { feed, index }: IActionFeed = yield select(selectActionFeed);
  const homeIndex = feed.findIndex(item => item.courseNodeId === action.payload.homeCourseNodeId);

  if (homeIndex > -1) yield put(yield call(goToIndex, homeIndex));
}

function* watchHome() {
  yield takeEvery(homeRequest.fulfilled, homeFullfilledSaga);
}

export function* homeSaga() {
  yield all([fork(watchHome)]);
}
